import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import loginView from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: loginView
  },
  {
    path: '/login',
    name: 'login',
    component: ()=>import("@/views/login.vue"),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },{
    path: "/home",
    name: "Home",
    component: ()=>import("@/views/home.vue")
  },
  {
    path: "/userMsg",
    name: "userMsg",
    component: () => import("@/views/userMsg.vue")
  },
  {
    path: "/dataSubmission",
    name: "dataSubmission",
    component: () => import("@/views/dataSubmission.vue")
  },
  {
    path: "/payMsg",
    name: "payMsg",
    component: () => import("@/views/payMsg.vue")
  },{
    path: "/confirmPay",
    name: "confirmPay",
    component: () => import("@/views/confirmPay.vue")
  }, {
    path: "/ticketDownload",
    name: "ticketDownload",
    component: () => import("@/views/ticketDownload.vue")
  }
  , {
    path: "/results",
    name: "results",
    component: () => import("@/views/results.vue")
    }, {
      path: "/admission",
      name: "admission",
      component: () => import("@/views/admission.vue")
    }
]

const router = new VueRouter({
  routes
})

export default router
